const videoModal = () => {
  $('#video-modal').on('show.bs.modal', function (event) {
    var button = $(event.relatedTarget);
    var videoUrl = button.data('video');
    var modal = $(this);
    const iframeHTML = `<iframe allowfullscreen frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen src="${videoUrl}"></iframe>`;
    modal.find('.modal-video__wrapper').append(iframeHTML);
  });

  $('#video-modal').on('hide.bs.modal', function () {
    $(this).find('iframe').remove();
  });
};

export default videoModal;
